module.exports = __webpack_public_path__ + "static/media/partner-btm-1.12981e72.png";